<template>
  <div style="border: 1px solid #ccc;">
    <Toolbar
      style="border-bottom: 1px solid #ccc"
      :editor="editor"
      :default-config="toolbarConfig"
      :mode="mode"
    />
    <Editor
      v-model="html"
      style="height: 500px; overflow-y: hidden;"
      :default-config="editorConfig"
      :mode="mode"
      @onCreated="onCreated"
    />
  </div>
</template>

<script>

import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { getToken } from '@/utils/auth'

export default {
  name: 'MyEditor',
  components: { Editor, Toolbar },
  props: {
    value: {
      type: String,
      default: '',
      required: true
    }
  },
  data() {
    return {
      editor: null,
      html: this.value,
      toolbarConfig: {},
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            customUpload(file, insertFn) {
              const formData = new FormData()
              formData.append('file', file)
              formData.append('oss', 1)
              fetch(process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile', {
                method: 'POST',
                headers: {
                  'Authorization': 'Bearer ' + getToken()
                },
                body: formData
              })
                .then(res => res.json())
                .then(res => {
                  insertFn(res.data.path)
                })
            }
          },
          insertVideo: {
            onInsertedVideo(videoNode) {
              // 屏蔽插入行为
              this.msgError('视频插入被禁止')
              return false
            }
          }
        }
      },
      mode: 'default' // or 'simple'
    }
  },
  watch: {
    value(newVal) {
      if (newVal !== this.html) {
        this.html = newVal
      }
    },
    html(newVal) {
      if (newVal !== this.value) {
        this.$emit('input', newVal)
      }
    }
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy()
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor)
    }
  }
}
</script>
<style src='@wangeditor/editor/dist/css/style.css'></style>

